import Storage from "./Storage";
import Http from "./Http";

const storage = new Storage('filesystem');

export default {

    /**
     * Requests a remote file ( will use a local copy to prevent redownload of large files )
     */
    request(path) {

        return new Promise((resolve, reject) => {
            // Try to get a local copy of the file
            storage.get(path).then(r_file => {

                // No file exists
                if (r_file.data === undefined) {
                    // console.log(`'${path}' does not exist.`);

                    // Request file from the server
                    Http.get(path).then(r_get => {
                        storage.put(r_get.path, r_get.data);
                        resolve(r_get); // Return file
                    });
                } else {

                    // Local file exists, but validate it hasn't expired?
                    Http.head(r_file.path).then(r_head => {
                        let lastModified = r_head.headers['last-modified'];
                        let timeDifference = r_file.date - lastModified;

                        // Has it expired?
                        if (timeDifference < 0) {
                            // console.log(`'${path}' found ( out of date ${(-timeDifference / 1000 / 60).toFixed(2)} minutes. ).`);
                            // Yes, out of date.
                            Http.get(path).then(r_get => {
                                storage.put(r_get.path, r_get.data);
                                resolve(r_get); // Return file
                            });
                        } else {
                            // console.log(`'${path}' found.`);
                            // Local file is up-to-date.
                            resolve(r_file); // Return file
                        }
                    });
                }
            });
        });
    }
};